var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAni9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.192 0.669982L14.76 8.30298C14.8836 8.37261 14.9865 8.47386 15.058 8.59633C15.1296 8.71881 15.1673 8.85812 15.1673 8.99998C15.1673 9.14184 15.1296 9.28115 15.058 9.40363C14.9865 9.52611 14.8836 9.62735 14.76 9.69698L1.192 17.33C1.07022 17.3984 0.932636 17.4338 0.792939 17.4326C0.653243 17.4313 0.516305 17.3935 0.395751 17.323C0.275198 17.2524 0.175231 17.1514 0.105799 17.0302C0.0363677 16.909 -0.000108409 16.7717 2.4202e-07 16.632V1.36798C6.61928e-05 1.22836 0.0366697 1.0912 0.106173 0.970109C0.175676 0.849021 0.275659 0.748232 0.396183 0.677757C0.516708 0.607282 0.653578 0.569577 0.793189 0.568388C0.932801 0.5672 1.07029 0.601569 1.192 0.669982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni9);
export default __webpack_public_path__ + "static/media/Ani9.dea13d35a28e20ff898c82f7ba3f0d84.svg";
export { ForwardRef as ReactComponent };